module.exports = __webpack_public_path__ + "250a6101694c86d3a244eb499ad67b75.png";